import React, { useState } from "react"
import { ScrollView, View } from "react-native"
import styles from "./styles"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseFontFamily } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const PersonalData = (props) => {
    const data = [
        {
            title: "1. Quelles sont les données personnelles traitées ?",
            content:
                "Les données personnelles vous concernant collectées et traitées sont principalement vos choix de paramétrage de votre terminal, vos nom, prénom, adresse mail, vos préférences ainsi que vos logs de connexion."
        },
        {
            title: "2. Comment collectons-nous vos données personnelles ?",
            content:
                "Ces données sont collectées soit sur la base de votre consentement, soit sont nécessaires à l’exécution de vos commandes."
        }
    ]

    return (
        <View style={styles.container}>
            <ScrollView   keyboardShouldPersistTaps={"handled"} showsVerticalScrollIndicator={false} contentContainerStyle={{ paddingBottom: 100 }}>
                <View style={styles.header}>
                    <BreeSerifText style={styles.title}>Données personnelles</BreeSerifText>
                    <OpenSansText defaultFontFamily={baseFontFamily.OpenSansRegular} fontSize={RFValue(16)}>
                        Consultez notre Politique de confidentialité.
                    </OpenSansText>
                </View>

                <OpenSansText
                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                    fontSize={RFValue(16)}
                    style={{ marginBottom: 18 }}
                >
                    L’application IVEHTE est opérée par la société IVEHTE SAS, dont le siège social est situé au 26
                    avenue Jean Rieux, 31500 Toulouse, ayant la qualité de responsable de traitement ou co-responsable
                    de traitement au sens de la réglementation en matière de données personnelles, notamment le
                    Règlement (UE) sur la Protection des Données Personnelles des personnes physiques (RGPD).
                </OpenSansText>

                <OpenSansText
                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                    fontSize={RFValue(16)}
                    style={{ marginBottom: 18 }}
                >
                    Les traitements de vos données sont réalisés conformément à la réglementation sur la protection des
                    données.
                </OpenSansText>

                {data.map((item, index) => (
                    <View key={index} style={styles.item}>
                        <BreeSerifText fontSize={RFValue(18)} style={styles.contentTitle}>
                            {item.title}
                        </BreeSerifText>

                        <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(16)}>
                            {item.content}
                        </OpenSansText>
                    </View>
                ))}
            </ScrollView>
        </View>
    )
}

export default PersonalData
